import factoryStore from '../components/factory-store'

const researchCouncil = {
  ...factoryStore('ResearchCouncil'),
}

const researchCouncilStore = {
  ...researchCouncil,
}

export default researchCouncilStore
